module.exports = __webpack_public_path__ + "media/images/lb/723-f029bc9a2955e4d00c658f9928af5d74.svg";